import React, { useState, useContext } from 'react';
import { navigate } from '@reach/router';

import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import AuthContext from '../../services/firebase/AuthContext';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const VerifyEmailPage = () => {
    const classes = useStyles();
    const [message, setMessage] = useState();
    const { verify, logout } = useContext(AuthContext);

    const handleSignOut = () => {
        logout().then(() => navigate("/"));
    }

    const handleSubmit = () => {
        verify().then(
            setMessage({ severity: 'success', text: 'Your new verification email has been sent' })
        )
            .catch(error => {
                setMessage({ severity: 'error', text: error.message })
            });
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h6">The Intermediary Cooperative</Typography>
                <Avatar className={classes.avatar}>
                    <CheckCircleIcon />
                </Avatar>
                <Typography variant="h5">Email Verification</Typography>
                <div className={classes.form} >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Alert severity="info" variant="filled">We've sent you an email to verify your identity. It may take a few minutes to arrive. Please check your inbox and spam folder. When the email arrives, click on the link to activate your account</Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <Button fullWidth disabled={!!message} onClick={handleSubmit} variant="contained" color="secondary">
                                Send me another verification email
                                </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={handleSignOut} variant="outlined" fullWidth style={{ marginTop: '1rem'}}>Sign Out</Button>
                        </Grid>
                    </Grid>
                    {
                        message && <Alert onClose={() => setMessage(undefined)} variant="filled" severity={message.severity} style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>{message.text}</Alert>
                    }
                </div>
            </div>
        </Container>
    );

}

const VerifyEmailPagePath = '/verify';

export {
    VerifyEmailPagePath
}

export default VerifyEmailPage;